{
  "sspi" : [
    {
      "type" : "SSPI_NOT_RECEIVED",
      "description" : "SSPI notification not received"
    },
    {
      "type" : "SECURITY_LEVEL_DIFFERS",
      "description" : "Security level differs from level terminal"
    },
    {
      "type" : "CSO_DATA_INCOMPLETE",
      "description" : "CSO date incomplete"
    },
    {
      "type" : "SECURITY_MATTERS_MISSING",
      "description" : "Security matters need to be explained further"
    },
    {
      "type" : "ISCC_INCORRECT",
      "description" : "ISCC is incorrect"
    },
    {
      "type" : "SSP_INCORRECT",
      "description" : "SSP is incorrect"
    },
    {
      "type" : "PORT_FACILITIES_DATA_INCOMPLETE",
      "description" : "Port facilities data incomplete"
    },
    {
      "type" : "SHIP_TO_SHIP_ACTIVITIES_INCORRECT",
      "description" : "Ship-to-ship activities are incorrect"
    }
  ],
  "emas" : [
    {
      "type" : "NOTIFICATION_NOT_RECEIVED",
      "description" : "Waste notification not received"
    },
    {
      "type" : "NOTIFICATION_INCORRECT",
      "description" : "Waste notification not complete"
    },
    {
      "type" : "NO_CAPACITY_FOR_WASTE",
      "description" : "Free waste capacity not sufficient"
    }
  ],
  "emgs" : [
    {
      "type" : "DG_NOTIFICATION_NOT_RECEIVED",
      "description" : "DG cargo notification not received"
    },
    {
      "type" : "DG_DISCHARGE_INFORMATION_NOT_RECEIVED",
      "description" : "DG cargo to discharge not received"
    },
    {
      "type" : "DG_DISCHARGE_INFORMATION_INCORRECT",
      "description" : "DG cargo to discharge not complete"
    },
    {
      "type" : "DG_TRANSIT_INFORMATION_NOT_RECEIVED",
      "description" : "DG cargo in transit not received"
    },
    {
      "type" : "DG_TRANSIT_INFORMATION_INCORRECT",
      "description" : "DG cargo in transit not complete"
    },
    {
      "type" : "DG_TO_LOAD_INFORMATION_NOT_RECEIVED",
      "description" : "DG cargo to load not received"
    },
    {
      "type" : "DG_TO_LOAD_INFORMATION_INCORRECT",
      "description" : "DG cargo to load not complete"
    },
    {
      "type" : "DG_CARGO_NOT_ALLOWED_AT_BERTH",
      "description" : "Berthing not allowed on this berth due to vessel's DG cargo"
    },
    {
      "type" : "DG_OTHER_REASONS",
      "description" : "The harbourmaster needs additional information about the cargo"
    },
    {
      "type" : "CLEANING_NOTIFICATION_NOT_RECEIVED",
      "description" : "Cleaning Notification not received"
    },
    {
      "type" : "CLEANING_NOTIFICATION_INCORRECT",
      "description" : "Cleaning notification information incomplete"
    }
  ],
  "ekh" : [
    {
      "type" : "LENGTH",
      "description" : "Length"
    },
    {
      "type" : "BEAM",
      "description" : "Beam"
    },
    {
      "type" : "VERTICAL_TIDE",
      "description" : "Vertical tide"
    },
    {
      "type" : "HORIZONTAL_TIDE",
      "description" : "Horizontal tide"
    },
    {
      "type" : "BERTH",
      "description" : "Berth type"
    },
    {
      "type" : "PILOTAGE",
      "description" : "Pilotage"
    },
    {
      "type" : "PARTICULARS",
      "description" : "Particulars"
    },
    {
      "type" : "APPROVED_WITH_REMARKS",
      "description" : "Remarks"
    }
  ],
  "mdoh" : [
    {
      "type" : "HEALTH_MEASURES_IMPOSED",
      "description" : "Health measures imposed"
    },
    {
      "type" : "DECLARATION_INVALID",
      "description" : "Declaration invalid"
    }
  ]
}
